const locale = {
	// #region ERP Orders fields
	DETAILS_ERP_ORDERS_FIELD_CODE: 'ERP Code',
	DETAILS_ERP_ORDERS_FIELD_DATE_ORDER: 'Order date',
	DETAILS_ERP_ORDERS_FIELD_DATE_DATE_REQDELIVERY: 'Requested delivery date',
	DETAILS_ERP_ORDERS_FIELD_DATE_DATE_PROMDELIVERY: 'Promised delivery date',
	DETAILS_ERP_ORDERS_FIELD_COMPANY: 'Customer',
	DETAILS_ERP_ORDERS_FIELD_BILL_COMPANY: 'Billing Company',
	DETAILS_ERP_ORDERS_FIELD_SALESPERSON: 'External assigned User',
	DETAILS_ERP_ORDERS_FIELD_PRICING_GROUP: 'Pricing group',
	DETAILS_ERP_ORDERS_FIELD_DISCOUNT_GROUP: 'Discount group',
	DETAILS_ERP_ORDERS_FIELD_SHIPPING_METHOD: 'Shipping method',
	DETAILS_ERP_ORDERS_FIELD_SHIPPING_AGENT: 'Shipping agent',
	DETAILS_ERP_ORDERS_FIELD_PAYMENT_TERMS: 'Payment terms',
	DETAILS_ERP_ORDERS_FIELD_PAYMENT_METHOD: 'Payment method',
	DETAILS_ERP_ORDERS_FIELD_EXTERNAL_NUMBER: 'External number',
	DETAILS_ERP_ORDERS_FIELD_TOT_TAX_EXCL: 'Total (tax excluded)',
	DETAILS_ERP_ORDERS_FIELD_TOT_TAX_INCL: 'Total (tax included)',
	// #endregion

	// #region ERP Orders Lines
	DETAILS_ERP_ORDERS_LINES_FIELD_ERP_ID: 'NAV Code',
	DETAILS_ERP_ORDERS_LINES_FIELD_DESCRIPTION: 'Description',
	DETAILS_ERP_ORDERS_LINES_FIELD_ITEM: 'Item',
	DETAILS_ERP_ORDERS_LINES_FIELD_ITEM_SERIES: 'Series',
	DETAILS_ERP_ORDERS_LINES_FIELD_ITEM_MEASURES: 'Measures',
	DETAILS_ERP_ORDERS_LINES_FIELD_BASE_PRICE: 'Base price',
	DETAILS_ERP_ORDERS_LINES_FIELD_DISCOUNT: 'Discount',
	DETAILS_ERP_ORDERS_LINES_FIELD_UNIT_PRICE: 'Unit price',
	DETAILS_ERP_ORDERS_LINES_FIELD_QUANTITY: 'Quantity',
	DETAILS_ERP_ORDERS_LINES_FIELD_MEASURE_UNIT: 'Measure unit',
	DETAILS_ERP_ORDERS_LINES_FIELD_TOT_TAX_EXCL: 'Total (tax excluded)',
	DETAILS_ERP_ORDERS_LINES_FIELD_TOT_TAX_INCL: 'Total (tax included)',
	// #endregion

	// #region Details Billing Company section
	DETAILS_BILLING_COMPANY_SECTION: 'Billing Address',
	DETAILS_BILLING_COMPANY_SUBHEADER: 'View the billing address',
	// #endregion

	// #region Details Shipping Company section
	DETAILS_SHIPPING_ADDRESS_SECTION: 'Shipping Address',
	DETAILS_SHIPPING_ADDRESS_SUBHEADER: 'View and edit the shipping address'
	// #endregion
};

export default locale;
